export default __webpack_public_path__ + "static/media/chatting-presentation.22e55419.png";